import React from 'react';

const LoadBtn = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <div
        className="spinner-border spinner-border-sm me-2"
        role="status"
        style={{fontSize: '10px', width: '20px', height: '20px'}}
      />
      <span>Loading...</span>
    </div>
  );
};

export default LoadBtn;
